import { z } from "zod";
import { AlignmentHorizontalOption } from "@ecp-redux/dto/themeSettings/themeSettings.types";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";
import { LinkContentScheme } from "@ecp-boxes/settingsPatterns/contentPatterns.scheme";

export const BoxListOfButtonsContentSettingsScheme = z.object({
  buttonsList: z
    .array(
      LinkContentScheme.and(z.object({ icon: themeScheme.IButtonIconSchema }))
    )
    .default([]),
});

export type TBoxListOfButtonsContentSettings = z.infer<
  typeof BoxListOfButtonsContentSettingsScheme
>;

export type TButtonList =
  TBoxListOfButtonsContentSettings["buttonsList"][number];

export const BoxListOfButtonsContentScheme = z.object({
  buttonsLabels: z.array(z.string()).default([]).catch([]),
});

export type TBoxListOfButtonsContent = z.infer<
  typeof BoxListOfButtonsContentScheme
>;

export const BoxListOfButtonsDisplaySettingsScheme = z.object({
  buttonsStyle: themeScheme.ButtonReadoutValueScheme.default(
    themeScheme.ButtonReadoutValueScheme.parse({})
  ).catch(themeScheme.ButtonReadoutValueScheme.parse({})),
  boxWidth: z.number().default(100),
  spaceBetweenButtons: z.number().default(5),
  spaceBetweenRows: z.number().default(5),
  alignment: z
    .nativeEnum(AlignmentHorizontalOption)
    .default(AlignmentHorizontalOption.CENTER),
  padding: themeScheme.SpacingScheme,
  vertical: z.boolean().default(false),
});

export type TBoxListOfButtonsDisplaySettings = z.infer<
  typeof BoxListOfButtonsDisplaySettingsScheme
>;
